import React, {useState} from 'react';
import useMortgage from "../../../../../../../../../providers/mortgage/useMortgage";
import {LoadingOutlined} from "@ant-design/icons";
import {Button, Popover, Tag} from "antd";
import {UploadStatuses} from "../../../../../../../../../../models";
import useBackendUsers from "../../../../../../../../../providers/mortgage/useBackendUsers";
import dayjs from "dayjs";
import {LONGDATETIME12} from "../../../../../../../../../../assets/scripts/constants";

function StatusChanger({uploadId}) {
    const mortgage = useMortgage()
    const [changing, setChanging] = useState(false)
    const {getBySub, me} = useBackendUsers()
    const row = mortgage.uploads.find(item => item.id === uploadId)

    const options = {
        "Acceptable": UploadStatuses.ACCEPTABLE,
        "For Advisor Review": UploadStatuses.REVIEWING,
        "Rejected": UploadStatuses.REJECTED,
        "Pending": UploadStatuses.PENDING,
        "Expired": UploadStatuses.EXPIRED
    }

    const betterOptions = {
        [UploadStatuses.ACCEPTABLE]: {
            label: "Acceptable",
            desc: "The uploads is clear and meets the requirements",
            props: {className: 'button-success'}
        },
        [UploadStatuses.REVIEWING]: {
            label: "For Advisor Review",
            desc: "The upload needs to be looked at by an advisor",
            props: {className: 'button-orange'}
        },
        [UploadStatuses.REJECTED]: {
            label: "Rejected",
            desc: "The upload does not meet the requirements",
            props: {danger: true}
        },
        [UploadStatuses.PENDING]: {
            label: "Pending",
            desc: "The upload has not been reviewed yet",
            props: {className: 'button-orange'}
        },
        [UploadStatuses.EXPIRED]: {
            label: "Expired",
            desc: "The upload has expired and will not be bundled",
            props: {danger: true}
        }
    }
    const handleExaminedChange = async () => {
        setChanging(true)
        await mortgage.mutate({
            update: {
                target: `uploads[${uploadId}]`,
                pairs: {
                    examined: !row.examined,
                    examinedBy: me.sub,
                }
            }
        })
        setChanging(false)
    }
    const handleStatusChange = async (status) => {
        setChanging(true)

        await mortgage.mutate({
            update: {
                target: `uploads[${uploadId}]`,
                pairs: {
                    status,
                    statusOn: dayjs().toISOString(),
                    statusBy: me.sub,
                }
            }
        })
        setChanging(false)
    }
    const handleNotVerifiableChange = async () => {
        setChanging(true)
        await mortgage.mutate({
            update: {
                target: `uploads[${uploadId}]`,
                pairs: {
                    verifiable: !row.verifiable,
                }
            }
        })
        setChanging(false)
    }
    const handleRejectedReason = async (e) => {
        const target = `uploads[${uploadId}].reason`
        const value = e.target.value
        await mortgage.mutate({
            update: {
                target,
                value
            }
        })
    }

    if (!row) return null

    let ticker = getBySub(row.statusBy)
    let statusOn = row.statusOn ? dayjs(row.statusOn) : false


    return (
        <>
            <div className="d-row j-between">
                <span>Status {changing && <LoadingOutlined/>}</span>
                {statusOn && (
                    <Popover content={statusOn.format(LONGDATETIME12)} trigger="hover">
                        <Tag color={ticker.color}>{ticker.firstName}</Tag>
                    </Popover>
                )}

            </div>

            {Object.keys(betterOptions).map(key => {
                const item = betterOptions[key]
                const props = row.status === key ? {...item.props} : {}
                return <BigButton key={key} {...props} disabled={changing} onClick={() => handleStatusChange(key)} label={item.label} desc={item.desc}/>
            })}
            <BigButton className={row.examined ? 'button-success' : ''} disabled={changing} onClick={() => handleExaminedChange()} label={"Examined"} desc="You've checked the transactions and made queries"/>
            <BigButton label="Supplementary Document" desc="Will be bundled, but has no collectable data" className={`j-start h-auto ${row.verifiable === false ? 'button-danger' : ''}`} disabled={changing}

                    onClick={() => handleNotVerifiableChange()}/>
        </>

    );
}

function BigButton({label, desc, ...props}) {
    props.className = (props.className || '') +' j-start h-auto';
    return (
        <Button {...props} size="large">
            <span className="d-col py-6 j-start a-start ">
                <h4 className="m-0"> {label} </h4>
                <small className="d-block"> {desc} </small>
                </span>
        </Button>
    );
}

export default StatusChanger;